(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("PersonalInformationCtrl", ["accountsResource", "myAccountResource", "authService", "frameworkService", "organizationsFilterResource", "messageService", "profileRecord", "REG_EXP", "calendarSettingsService", "publicResource", "$q", "$state", "$scope", "$timeout", "$translate", "_", personalInformationCtrl]);
    function personalInformationCtrl(accountsResource, myAccountResource, authService, frameworkService, organizationsFilterResource, messageService, profileRecord, REG_EXP, calendarSettingsService, publicResource, $q, $state, $scope, $timeout, $translate, _) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        var person = $state.params.personSeq;
        vm.phonePattern = REG_EXP.phone;
        vm.phoneNumberMask = profileRecord.phoneMask;
        vm.faxNumberMask = profileRecord.faxMask;
        vm.adminNotes = profileRecord === null || profileRecord === void 0 ? void 0 : profileRecord.adminNotes;
        vm.data = frameworkService.data;
        vm.profileRecord = profileRecord;
        vm.myAccount = $state.current.name === "main.myAccount";
        vm.showDropDown = false;
        vm.showSignupCode = false;
        vm.showReadOnly = false;
        //1 Super & Site admin always see dropdown only (myAccount & others)
        //2 Org admin can't change their own org - show readonly
        //3 Org admin can only change their user's org if hierarchy is enabled - show drop down
        //4 Group admin treat as a user when editing their own account - check settings
        //5 Group admin can't change their user's org - show read only
        //6 User - check settings
        if (vm.data.tenantFeatures.organization) {
            if (authService.isSuperOrSiteAdmin()) {
                vm.showDropDown = true;
            }
            else if (authService.isOrgAdmin()) {
                if (vm.myAccount || person == authService.authentication.userPersonSeq)
                    vm.showReadOnly = true;
                else if (vm.data.tenant.tenantFeaturesOrganizationHierarchyType == 2)
                    vm.showDropDown = true;
            }
            else if (authService.isGroupAdmin()) {
                if (vm.myAccount) {
                    vm.showDropDown = vm.data.tenant.tenantFeaturesOrganizationDropdown;
                    vm.showSignupCode = vm.data.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled;
                    vm.showReadOnly = !vm.showDropDown && !vm.showSignupCode;
                }
                else {
                    vm.showReadOnly = true;
                }
            }
            else {
                vm.isUser = true;
                vm.showDropDown = vm.data.tenant.tenantFeaturesOrganizationDropdown;
                vm.showSignupCode = vm.data.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled;
                vm.showReadOnly = !vm.showDropDown;
            }
        }
        vm.model = {
            id: profileRecord.id,
            gender: profileRecord.selfRegistrationEnabledFields.gender ? profileRecord.selfRegistrationEnabledFields.gender.value : null,
            birthdate: profileRecord.selfRegistrationEnabledFields.birthdate ? profileRecord.selfRegistrationEnabledFields.birthdate.value ? new Date(profileRecord.selfRegistrationEnabledFields.birthdate.value) : null : null,
            phoneNumber1: profileRecord.selfRegistrationEnabledFields.phone1 ? profileRecord.selfRegistrationEnabledFields.phone1.value : null,
            phoneNumber2: profileRecord.selfRegistrationEnabledFields.phone2 ? profileRecord.selfRegistrationEnabledFields.phone2.value : null,
            faxNumber: profileRecord.selfRegistrationEnabledFields.fax ? profileRecord.selfRegistrationEnabledFields.fax.value : null,
            organizationName: profileRecord.selfRegistrationEnabledFields.organizationName ? profileRecord.selfRegistrationEnabledFields.organizationName.value : null,
            organizationId: profileRecord.organizationId,
            customQuestions: {},
            adminNote: profileRecord === null || profileRecord === void 0 ? void 0 : profileRecord.adminNote
        };
        if (vm.model.organizationId) {
            vm.model.organization = {
                id: vm.model.organizationId,
                name: vm.model.organizationName
            };
        }
        else {
            vm.model.organization = null;
        }
        _.each(vm.profileRecord.customQuestions, function (question) {
            if (question.answer !== "") {
                if (question.typeId === 1) {
                    vm.model.customQuestions[question.id] = parseInt(question.answer);
                }
                else if (question.typeId === 2) {
                    if (question.answer)
                        vm.model.customQuestions[question.id] = new Date(question.answer);
                }
                else {
                    vm.model.customQuestions[question.id] = question.answer;
                }
            }
            else {
                vm.model.customQuestions[question.id] = "";
            }
        });
        //Date picker config
        vm.format = "yyyy-MM-dd";
        calendarSettingsService.calendarSetup($scope);
        vm.open = calendarSettingsService.open;
        vm.refreshOrganizations = function (val) {
            vm.orgSearch = val;
            organizationsFilterResource.getCachedEnabled({ name: val }, function (result) {
                vm.organizations = result;
                if (val === "") {
                    if (vm.model.organization != null && vm.model.organization.id > 0) {
                        if (!_.find(vm.organizations, { 'id': vm.model.organization.id })) {
                            vm.organizations.push(vm.model.organization);
                        }
                    }
                }
                if (vm.myAccount && vm.data.tenant.tenantFeaturesUserCanAddOrganization) {
                    vm.organizations.push({ name: $translate.instant('public.selfRegistration.addOrganization'), id: -1 });
                }
            });
        };
        vm.onSelect = function (item) {
            vm.model.organizationId = item.id;
            vm.showOtherOrganization = item.id == -1;
            if (item.id == -1)
                vm.model.addOrganizationName = vm.orgSearch;
        };
        vm.organizationChanged = function () {
            vm.model.organizationId = null;
        };
        vm.checkSignupCode = function (code) {
            return $q(function (resolve, reject) {
                if (code) {
                    publicResource.isSignupCodeValid({ actionValue: code }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    }, function () {
                        messageService.error("common.genericError");
                        reject();
                    });
                }
                else {
                    resolve(true);
                }
            });
        };
        vm.signupCodeChanged = function () {
            vm.model.organizationId = null;
            vm.model.organizationName = "";
            if (vm.model.signupCode) {
                publicResource.getOrganizationNameBySignupCode({ actionValue: vm.model.signupCode }, function (result) {
                    vm.model.organizationName = result.value;
                    vm.showDropDown = false;
                    vm.showReadOnly = true;
                }, function () {
                    messageService.error("common.genericError");
                });
            }
            else {
                vm.showDropDown = vm.data.tenant.tenantFeaturesOrganizationDropdown;
                vm.showReadOnly = !vm.showDropDown;
                //reset to previous org
                vm.model.organizationId = vm.model.organization.id;
                vm.model.organizationName = vm.model.organization.name;
            }
        };
        vm.save = function () {
            if (vm.saving)
                return;
            vm.saving = true;
            $timeout(function () {
                if (vm.form.$valid) {
                    if (vm.myAccount) {
                        if (vm.model.organizationId < 0) {
                            vm.model.organizationId = null;
                            vm.model.organizationName = vm.model.addOrganizationName;
                        }
                        myAccountResource.updateMyPersonalInformation(vm.model, function () {
                            messageService.success("account.profile.edit.personalInformation.success");
                            $scope.$close();
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                    else {
                        accountsResource.updatePersonalInformation({ personSeq: person }, vm.model, function () {
                            messageService.success("account.profile.edit.personalInformation.success");
                            $scope.$close();
                        }, function (error) {
                            vm.saving = false;
                            messageService.error(error);
                        });
                    }
                }
                else {
                    vm.showErrors = true;
                    vm.saving = false;
                }
            }, 210);
        };
    }
}());
